import React from "react";
import IntegrationDetail from "./IntegrationDetail";

const IntegrationRER = () => <IntegrationDetail integrationKey="rer" />;

export default IntegrationRER;
